import { useState, useRef, useEffect } from 'react';
import { Trans } from '@lingui/react';
import { Button } from './joy/Button';
import Collapse from '@mui/material/Collapse';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { RichUserText } from './RichUserText';

const DEFAULT_COLLAPSED_SIZE = 83;

export const CommentCell = ({ colSpan, comment }: { colSpan: number; comment: string }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [partlyHidden, setPartlyHidden] = useState(false);
  const [collapsedSize, setCollapsedSize] = useState(DEFAULT_COLLAPSED_SIZE);

  useEffect(() => {
    const elm = ref.current;
    // @ts-expect-error TS18048
    const partlyHidden = elm?.scrollHeight > elm?.clientHeight;
    setPartlyHidden(partlyHidden);
    if (elm && !partlyHidden) {
      setCollapsedSize(Math.min(elm?.clientHeight, DEFAULT_COLLAPSED_SIZE));
    }
  }, [comment]);

  return (
    <td colSpan={colSpan}>
      <Collapse ref={ref} collapsedSize={collapsedSize} in={open}>
        <RichUserText>{comment}</RichUserText>
      </Collapse>
      {partlyHidden && (
        <Button
          variant="plain"
          onClick={() => setOpen(!open)}
          endDecorator={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        >
          {open ? <Trans id="Show less" /> : <Trans id="Show more" />}
        </Button>
      )}
    </td>
  );
};
